import { render, staticRenderFns } from "./EmailsCard.vue?vue&type=template&id=67d84865"
import script from "./EmailsCard.vue?vue&type=script&lang=js"
export * from "./EmailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports